<template>
  <b-container
    fluid
    :class="{
      'test-type-box': true,
      'border-top-less': false,
    }"
  >
    <b-row class="mx-0">
      <span class="test-type-title">{{ testType.name }}</span>
    </b-row>
    <b-row
      :class="{
        'd-flex': horizontal <= 0,
        'flex-column': horizontal <= 0,
        'mx-0': true,
      }"
    >
      <template v-if="isNotSetType()">
        <div
          v-for="test in testType.testType.test"
          :key="test.id"
          :class="`${horizontalCount()} text-left`"
        >
          <b-form-checkbox
            v-if="test.lab_type == (isOutLab ? 'outlab' : 'inlab')"
            :id="test.name"
            v-model="testSelectedComputed"
            :name="test.name"
            :value="test"
            >{{ test.name }}</b-form-checkbox
          >
        </div>
      </template>
      <template v-else>
        <div
          v-for="setTest in testType.testType"
          :key="setTest.id"
          :class="`${horizontalCount()} text-left`"
        >
          <b-form-checkbox
            :id="setTest.name"
            v-model="testSelectedComputed"
            :name="setTest.name"
            :value="setTest"
            >{{ setTest | setTestDescription }}</b-form-checkbox
          >
        </div>
      </template>
    </b-row>

    <!-- <blood-chemistry-test-checklist-component
      v-else-if="isBloodChemistry()"
      :is-out-lab="isOutLab"
      :tests="testType.testType.test"
      :test-selected.sync="testSelectedComputed"
    />

    <test-kit-test-checklist-component
      v-else-if="isTestKit()"
      :is-out-lab="isOutLab"
      :tests="testType.testType.test"
      :test-selected.sync="testSelectedComputed"
    /> -->
  </b-container>
</template>

<script>
import _ from "lodash";
import bloodChemistryTestChecklistComponent from "./bloodChemistryTestChecklistComponent";
import testKitTestChecklistComponent from "./testKitTestChecklistComponent";

export default {
  name: "TestTypeChecklistBox",
  components: {
    bloodChemistryTestChecklistComponent,
    testKitTestChecklistComponent,
  },
  filters: {
    setTestDescription(setTest) {
      // let tests = setTest.set_test_detail.map((test) => test.test_name);
      // return _.join(tests, ", ");
      return setTest.name;
    },
  },
  props: {
    testType: {
      required: true,
    },
    testSelected: {
      required: true,
    },
    setTest: {
      // default: true
    },
    horizontal: {
      default: 0,
    },
    bloodChemistry: {},
    testKit: {},
    isOutLab: {},
  },
  computed: {
    testSelectedComputed: {
      get() {
        return this.testSelected;
      },
      set(value) {
        return this.$emit("update:testSelected", value);
      },
    },
  },
  methods: {
    isNotSetType() {
      return _.isUndefined(this.setTest);
    },
    isBloodChemistry() {
      return !_.isUndefined(this.bloodChemistry);
    },
    isTestKit() {
      return !_.isUndefined(this.testKit);
    },
    horizontalCount() {
      if (this.horizontal <= 0) {
        return "col-auto";
      } else {
        return `col-lg-${this.horizontal}`;
      }
    },
  },
};
</script>

<style scoped>
.test-type-title {
  text-decoration: underline;
  font-weight: bold;
}

.test-type-box {
  border: 1px solid #000;
  padding-right: 1rem;
  padding-left: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 0.9rem;
}

.border-top-less {
  border-top: none;
}

.border-bottom-less {
  border-bottom: none;
}
</style>
